import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import UserContext from '../../context/UserContext.js';
import FiltrosPersonas from './FiltrosPersonas.js';
import NuevaPersonaFiltro from './NuevaPersonaFiltro.js';
import PanelAgregarResponsive from '../UI/PanelAgregarResponsive.js';
import CeldaOrdenable from '../UI/CeldaOrdenable.js';
import { TituloPagina } from '../funciones/Funciones.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import * as FuncionesOrdenamiento from '../funciones/FuncionesOrdenamiento.js';
import styles from './BasePersonas.module.css';

const BasePersonas = (props) => {
  const profesion = props.profesion;
  let [searchParameters] = useSearchParams();
  const [lista, setLista] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [ordenPor, setOrdenPor] = useState(FuncionesOrdenamiento.CamposOrdenamiento.APELLIDO);
  const [ascendente, setAscendente] = useState(true);
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  useEffect(() => {
    document.title = TituloPagina(BasePersonas.name + (profesion ? '.' + profesion : ''));
  }, [profesion]);

  const onBuscando = () => {
    setLista([]);
    setBuscando(true);
  };

  const onListaCargada = (personas) => {
    setBuscando(false);
    setLista(personas);
  };

  return (
    <div>
      <FiltrosPersonas
        searchParams={searchParameters}
        profesion={profesion}
        onBuscando={onBuscando}
        onListaCargada={onListaCargada}
        hasResults={lista && lista.length > 0}
      />
      <PanelAgregarResponsive
        Componente={NuevaPersonaFiltro}
        objeto="persona"
        lista={lista}
        onListaCargada={onListaCargada}
        puedeEditar={puedeEditar}
        buscando={buscando}
      >
        {!buscando && lista && lista.length === 0 && (
          <div className={`${styles.mensajeSinDatos}`}>
            No se encontraron personas para los filtros dados
          </div>
        )}
        {lista && lista.length > 0 && (
          <table className={`${styles.tablaPersonas}`}>
            <thead>
              <tr>
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.APELLIDO}
                  label="Apellido"
                  ordenPor={ordenPor}
                  ascendente={ascendente}
                  onChange={(campo, asc) => {
                    setOrdenPor(campo);
                    setAscendente(asc);
                  }}
                  className={styles.headerApellido}
                  title="Click para ordenar por apellido"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE}
                  label="Nombre"
                  ordenPor={ordenPor}
                  ascendente={ascendente}
                  onChange={(campo, asc) => {
                    setOrdenPor(campo);
                    setAscendente(asc);
                  }}
                  className={styles.headerNombre}
                  title="Click para ordenar por nombre"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.PAIS}
                  label="País"
                  ordenPor={ordenPor}
                  ascendente={ascendente}
                  onChange={(campo, asc) => {
                    setOrdenPor(campo);
                    setAscendente(asc);
                  }}
                  className={styles.headerPais}
                  title="Click para ordenar por país"
                />
                <CeldaOrdenable
                  campo={FuncionesOrdenamiento.CamposOrdenamiento.NACIMIENTO}
                  label="Nacimiento"
                  ordenPor={ordenPor}
                  ascendente={ascendente}
                  onChange={(campo, asc) => {
                    setOrdenPor(campo);
                    setAscendente(asc);
                  }}
                  className={styles.headerNacimiento}
                  title="Click para ordenar por nacimiento"
                />
              </tr>
            </thead>
            <tbody>
              {FuncionesOrdenamiento.ordenarPersonas(lista, ordenPor, ascendente).map((persona) => {
                return (
                  <tr key={persona.id}>
                    <td>
                      <Link to={'/persona/' + persona.id}>{persona.apellido}</Link>
                    </td>
                    <td>
                      <Link to={'/persona/' + persona.id}>{persona.nombre}</Link>
                    </td>
                    <td>{persona.paisNacimiento && persona.paisNacimiento.nombre}</td>
                    <td>
                      {FuncionesFecha.CamposToFechaCorta(
                        persona.anioNacimiento,
                        persona.mesNacimiento,
                        persona.diaNacimiento
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </PanelAgregarResponsive>
    </div>
  );
};

export default BasePersonas;
